import { MARKET_INFO_POLLING_INTERVAL, MARKET_LIST_POLLING_INTERVAL } from '@/constants/polling';
import { QUERY_KEYS } from '@/constants/query';
import { useQuery } from '@tanstack/react-query';
import { fetchMarketPairInfo, fetchMarketPairList } from './api';

export const useFetchMarketPairList = ({ chainId }: { chainId?: number }) => {
  return useQuery({
    queryKey: QUERY_KEYS.MARKET.PAIR_LIST(chainId),
    queryFn: async () => fetchMarketPairList({ chainId: chainId! }),
    refetchInterval: MARKET_LIST_POLLING_INTERVAL,
    enabled: !!chainId,
  });
};

export const useFetchMarketPairInfo = ({
  chainId,
  instrumentAddr,
  expiry,
}: {
  chainId?: number;
  instrumentAddr?: string;
  expiry?: number;
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.FUTURES.PAIR_INFO(chainId, instrumentAddr, expiry),
    queryFn: () =>
      fetchMarketPairInfo({
        chainId: chainId!,
        address: instrumentAddr!,
        expiry: expiry!,
      }),
    enabled: !!chainId && !!instrumentAddr && !!expiry,
    refetchInterval: MARKET_INFO_POLLING_INTERVAL,

    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
